import { memo } from 'react';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from '@material-ui/core';

type PimSectionProps = {
  value: boolean;
  onChange: (value: boolean) => void;
};

export const PimSection = memo(({ value, onChange }: PimSectionProps) => (
  <FormControl>
    <FormControlLabel
      control={
        <Checkbox
          id="pim-enabled"
          checked={Boolean(value)}
          onChange={event => onChange(event.target.checked)}
          color="primary"
        />
      }
      label="Enable PIM Access"
    />
    <FormHelperText>
      Recommended for production environments. (Applies only to Kubernetes
      access)
    </FormHelperText>
  </FormControl>
));
